import { render, staticRenderFns } from "./Document-notification.vue?vue&type=template&id=18e75e54"
import script from "./Document-notification.vue?vue&type=script&lang=js"
export * from "./Document-notification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports